import { render, staticRenderFns } from "./DownloadWorkOrderDetails.vue?vue&type=template&id=58538b90"
import script from "./DownloadWorkOrderDetails.vue?vue&type=script&lang=ts"
export * from "./DownloadWorkOrderDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports